import { render, staticRenderFns } from "./breaches.vue?vue&type=template&id=0b5350ec"
import script from "./breaches.vue?vue&type=script&lang=js"
export * from "./breaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports